import { takeLatest, call, put } from 'redux-saga/effects'
import myCoursesCategories from 'api/courses/MyCoursesCategories'
import * as fromActions from '../../actions/courses.action'

async function getList() {
  return myCoursesCategories({ search: '' })
}

function* getCourseFoldersListEffectSaga() {
  try {
    const { data } = yield call(getList)
    yield put(fromActions.Actions.coursesGetMyFoldersSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getCourseFoldersListWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_GET_MY_FOLDERS,
    getCourseFoldersListEffectSaga
  )
}
